
export default function ({ app, redirect }) {
  // only run this middleware on the client side if they are logged in
  if (!app.$auth.$state.loggedIn) {
    return
  }

  redirect('/my-kintell/dashboard')
}
